<template>
  <div class="progressBar-secondary">
    <div class="flex justify-content-center">
      <div class="progressBar-secondary__header">
        <h3>{{ title }}</h3>
        <span :class="title_highlight_class">{{ title_highlight }}</span>
      </div>

      <div v-if="button_reload" class="ml-5 mt-4">
        <p-button icon outline type="warning" @click.native.prevent="reload">
          <i class="fas fa-sync-alt"></i>
        </p-button>
      </div>
    </div>
    <div class="progressBar-secondary__bar" :class="classColor" :style="styleObject">
      <div v-if="loading" class="progressBar-secondary__value text-secondary">
        <i class="fa fa-spinner fa-spin"></i>
      </div>
      <div v-else>
        <div class="progressBar-secondary__value text-secondary">
          {{ progress }} / {{ total }} {{ unit_name }} &nbsp; ({{ percent }} %)
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
export default {
  name: 'ProgressBarSecondary',
  components: { MoonLoader },
  props: {
    unit_name: String,
    title: String,
    title_highlight: String,
    title_highlight_class: String,
    color: {
      type: String,
      default: 'progressBar-secondary__bar--green',
    },
    progress: {},
    total: {},
    loading: {
      default: false,
      Boolean,
    },
    button_reload: {
      default: false,
      Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    styleObject() {
      return {
        '--progress_width': this.percent + '%',
      };
    },
    classColor() {
      let className = '';
      if (this.color === 'green') className = { 'progressBar-secondary__bar--green': true };
      else if (this.color === 'yellow') className = { 'progressBar-secondary__bar--yellow': true };
      else className = { 'progressBar-secondary__bar--green': true };

      return className;
    },
    percent() {
      return Math.round((this.progress / this.total) * 100);
    },
  },
  methods: {
    reload() {
      this.$emit('reload');
    },
  },
};
</script>

<style scoped></style>
